"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SMS_PLUGINS = void 0;
exports.SMS_PLUGINS = {
    SIMPLE_TEXT: 'SIMPLE_TEXT',
    TWILIO: 'TWILIO',
    ZIPWHIP: 'ZIPWHIP'
};
//# sourceMappingURL=smsPlugins.js.map